<div style="display: flex;flex-direction: column;align-items: center;
justify-content: center;flex:1;align-self: center;">



  <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%;">
    <!-- <div style="justify-content: center;align-self: center;margin-top: 2%;"> -->
      <span *ngIf="ProductProgramId == 0" style="font-size: 25px;">{{'Product Improvement Program' | translate | async}}</span>
    <span *ngIf="ProductProgramId > 0" style="font-size: 25px;">{{'Product Improvement Program' | translate | async}}</span>

    <button  style="float: right; margin-bottom: 1%;" class="button button--primary"><span class="button__text"
      (click)="NavigateToSearch()">{{'Return to Search Screen' | translate | async}}</span></button>
   
    <!-- </div> -->
    <div class="search-options"
      style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;height:auto;">

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Select Built #" [formControl]="buildnoFormControl"  [(ngModel)]="Selectmodel" multiple required>
          <mat-option (click)="selectAll(ev)"    [value]="0"
          #ev
           >{{'Select All' | translate | async}}</mat-option>
          <mat-option [value]="model.ID" *ngFor="let model of modelList" (click)="valueChange(model.ID)" >{{model.modelName}}</mat-option>
        </mat-select>
      </mat-form-field>
      <!-- <span class="required-asterisk">*</span> -->
<!-- 
      <mat-form-field style="margin-left: 0px">
        <mat-select placeholder="Select Build #"  [formControl]="buildnoFormControl" [(ngModel)]="Selectmodel" multiple required>
           <mat-option (click)="selectAll(ev)"    [value]="0"
        #ev
         >Select All</mat-option>
          <mat-option *ngFor="let model of modelList"  [value]="model.ID" (click)="valueChange(model.ID)">{{model.modelName}}</mat-option>
        
        </mat-select>
        <mat-error *ngIf="buildnoFormControl.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field> -->




      <mat-form-field class="header-form-full-width">
        <mat-label> {{'Serial # Start' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="{{'Enter Serial # Start' | translate | async}}" [(ngModel)]="serialStart"  (focusout)=" checkBuiltNoStart($event)" required>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <mat-label> {{'Serial # End' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="{{'Enter Serial # End' | translate | async}}" [(ngModel)]="serialEnd"  (focusout)=" checkBuiltNoEnd($event)"  required>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-label> {{'PIP Number' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="{{'Enter PIP Number' | translate | async}}" [(ngModel)]="PIPNumber" required>
      </mat-form-field>



      <mat-form-field class="header-form-full-width">
        <mat-label> {{'Enter Heading' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="{{'Enter Heading' | translate | async}}" [(ngModel)]="PIPHeading" required>
      </mat-form-field>

      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>

        
  <div style="display: flex;" class="sc-row-margin">
    <div style="flex: 1">
      <h4 style="font-size: 14px;" class="get-label">{{'Enter PIP Description' | translate | async}}</h4>     
        <mat-form-field style="width: 1000px;">  
          <textarea class="sc-textarea" matInput [(ngModel)]="PIPDescription" [ngModelOptions]="{standalone: true}"></textarea>
        </mat-form-field>    
    </div>
  </div>

  
  <!-- <mat-form-field class="header-form-full-width invisible">
    <mat-select name="customer" class="invisible">
    </mat-select>
  </mat-form-field> -->

      
      <div style="display: flex;min-width: 100%;height:40px">
       
        <span style="cursor: pointer;font-size: 14px;">{{'Supporting Doc.' | translate | async}}</span>
          <div *ngFor="let form of attachmentList, let i =  index" style="display: flex;height:40px;justify-content: left;">
            <i style="cursor: pointer;vertical-align: bottom; margin-left: 10%;font-size: 40px;
            color: #3da14b;"
              class="material-icons" class="material-icons" (click)="onClickDownloadForm(form)">description</i>
              <span style="cursor: pointer;font-size: 13px; max-width: 10em;    overflow-wrap: break-word;">{{form.FileName}}</span>
            <span style=" white-space: nowrap;"><i class="material-icons sc-icon" (click) ="delete(i)">delete</i></span>
          </div>      
          <i   class="material-icons" (click)="openAttachDoc()" style="cursor: pointer;vertical-align: bottom; margin-left: 2%; ">add</i>        
      </div>

      <!-- <div style="min-width: 30%;width: 30%;"></div> -->
      <!-- <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field> -->
     
      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate" required>
        <mat-placeholder>{{'Program Start Date' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="endDate" >
        <mat-placeholder>{{'Program End Date' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>
  
      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Support Pro Associated with PIP' | translate | async}}" [(ngModel)]="supportProgramAssociateLevel">
          <mat-option [value]="level.Id" *ngFor="let level of PIPsupportLevelList" >{{level.SupportLevel}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-label>{{'Support Program Notes' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="{{'Enter Support Program Notes' | translate | async}}" [(ngModel)]="supportProgramNotes">
      </mat-form-field>
      
      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Select Status' | translate | async}}" [(ngModel)]="selectStatus" required>
          <mat-option [value]="status.Id" *ngFor="let status of PIPStatusList" >{{status.Status}}</mat-option>
        </mat-select>
      </mat-form-field>
      
      <div style="min-width: 30%;width: 30%;"></div>

      <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">
        <button (click)="ResetFields()" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
          >{{'Reset' | translate | async}}</span></button>
        <button  *ngIf="ProductProgramId == 0" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
          (click)="saveProductImprovement()" >{{'Save' | translate | async}}</span></button>
        <button *ngIf="ProductProgramId > 0" (click)="updateProdImprovement()" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
            >{{'Update' | translate | async}}</span></button>
        <button *ngIf="showGenerateButton" (click)="sendPIPNotificatinEmailtoUsers()" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
            >{{'Generate Alert' | translate | async}}</span></button>
        <button *ngIf="showGenerateButton_" (click)="sendPIPNotificatinEmailtoUsers_()" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
            >{{'Generate Alert' | translate | async}}</span></button>
      </div>

    </div>
  </mat-card>


  <!-- <div *ngIf="ProductProgramId > 0" style="width: 100%;">
    <div style="display: flex;min-width: 30%;height:40px; margin-top: 1%;">
      <span style="cursor: pointer;font-size: 17px;margin-left: 2%;"></span>

    </div>

    <table class="table table--full-width table--striped" style="margin-top: 9px;">

      <thead>
        <tr>
          <th style="display: flex;flex-direction: row;justify-content: space-between;">
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Date</span>

            </div>           
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Acion</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">User
              </span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Field
                Changed
              </span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">From</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">To</span>
            </div>


          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let audit of auditTrailList">
          <td style="min-width: 50px;display: flex;flex-direction: row;justify-content: space-between;">          
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.ModifiedDate
                | date:'dd MMM yyyy'}}</span>
            </div>
            
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.Action}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.ModifiedUserName}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.FieldName}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.OldValue}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.NewValue}}</span>
            </div>
           

          </td>
        </tr>
      </tbody>
    </table>

    <div style="display: flex;flex-direction: column;align-items: center;
  justify-content: center;min-height: 500px;align-self: center;">
    </div>

  </div> -->



</div>